import {
  IconDefinition,
  IconLookup,
  IconName
} from '@fortawesome/fontawesome-svg-core';

export const textIcon: IconDefinition & IconLookup = {
  prefix: 'fab',
  iconName: 'text' as IconName,
  icon: [
    448,
    512,
    [],
    'none',
    'M432 32a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32H264v304h40a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h40V112H64v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16z'
  ]
};

export const stairsIcon: IconDefinition & IconLookup = {
  prefix: 'fab',
  iconName: 'stairs' as IconName,
  icon: [
    100,
    100,
    [],
    'none',
    'M 88.894187,13.349653 H 75.858354 67.310207 v 8.548146 13.036436 H 54.274372 45.726226 v 8.548149 13.035835 H 32.689789 24.141641 v 8.548147 13.035835 H 2.557659 v 8.548146 h 30.13213 V 78.1022 65.066366 H 54.274372 V 56.518219 43.482384 H 75.858354 V 34.934235 21.897799 h 13.035833 8.548154 v -8.548146 z',
  ]
};

export const statueIcon: IconDefinition & IconLookup = {
  prefix: 'fab',
  iconName: 'statue' as IconName,
  icon: [
    100,
    100,
    [],
    'none',
    'M 50.000001,0.87620926 C 53.837858,11.917235 57.675715,22.958261 61.513572,33.999287 c 11.686603,0.238155 23.373206,0.47631 35.059809,0.714465 -9.314677,7.061883 -18.629353,14.123767 -27.94403,21.18565 3.38486,11.188214 6.76972,22.376428 10.15458,33.564642 C 69.189287,82.787502 59.594644,76.11096 50,69.434418 40.405356,76.110959 30.810711,82.787501 21.216067,89.464042 24.600928,78.275829 27.985788,67.087615 31.370649,55.899402 22.055973,48.837518 12.741296,41.775633 3.4266201,34.713749 15.113223,34.475595 26.799825,34.237441 38.486428,33.999287 42.324286,22.958261 46.162143,11.917235 50.000001,0.87620926 Z'
  ]
}

export const columnIcon: IconDefinition & IconLookup = {
  prefix: 'fab',
  iconName: 'column' as IconName,
  icon: [
    100,
    100,
    [],
    'none',
    'M 99.307838,50.000002 C 99.676865,71.680786 83.863735,92.30908 62.849037,97.645153 43.43672,103.02916 21.169043,95.169716 9.7285742,78.512925 -1.6384271,62.63998 -2.3896164,39.964144 8.336037,23.568937 18.693791,7.0444626 39.349174,-2.2666802 58.573467,1.4133904 77.242915,4.6178118 93.377617,19.344785 97.783979,37.839728 c 1.009833,3.969178 1.527479,8.064294 1.523859,12.160274 z'
  ]
}

export const stalacmiteIcon: IconDefinition & IconLookup = {
  prefix: 'fab',
  iconName: 'stalacmite' as IconName,
  icon: [
    100,
    100,
    [],
    'none',
    'm 74.415659,92.321351 c -4.943641,0.08102 -9.841762,-1.089484 -14.790343,-0.658213 -3.565886,-0.471723 -7.22558,0.729371 -9.905688,3.089052 -1.962324,1.335386 -5.447033,1.324308 -6.094083,1.821715 -3.85956,0.399841 -7.750871,0.28678 -11.573283,0.679078 -2.618647,-0.623551 -6.036085,-0.489443 -8.075905,-1.732656 1.155957,-3.724279 4.94719,-5.230686 7.705191,-7.514488 2.969895,-1.745463 3.119779,-6.066341 3.390628,-9.173885 0.977271,-3.506623 0.968227,-6.763139 0.834314,-10.383359 0.215923,-3.830242 -0.1664,-7.549928 0.655209,-11.170453 0.846053,-3.59887 2.294525,-6.963584 3.511139,-10.460921 0.866289,-3.295106 0.609567,-7.081046 1.683639,-10.061072 1.42479,-3.266581 3.711094,-6.049776 5.124971,-9.287309 1.837583,-3.091687 3.916701,-6.009869 3.773832,-9.893974 0.571828,-4.55039 1.017447,-9.2261117 1.445585,-13.7209267 3.030585,-2.95287215 6.303553,0.1796971 8.022745,2.5391129 3.780486,-0.6640017 2.841131,5.3726878 4.064949,7.7612308 0.861812,3.528943 1.440482,7.099871 1.327164,10.73674 -0.02487,3.466809 0.535472,6.773821 1.338634,10.143058 1.921669,3.216066 -0.39964,6.716109 0.466581,10.116214 -0.08226,4.045679 1.089512,8.062286 2.357768,11.873417 3.207109,1.44481 4.605866,4.867853 4.700711,8.604547 -0.214383,4.020444 0.705194,8.095625 -0.21518,12.020218 -0.141146,3.376494 0.09043,6.94965 1.137373,9.996727 1.650808,1.264756 0.198735,3.557255 -0.885951,4.676147 z',
  ]
}